import Http from "@/utils/request.js";

//授权登录
export function Authorized(data){
	return Http.request({
		url: `/auth/oauth/token`,
		method: 'post',
		header:{
			'content-type': 'application/x-www-form-urlencoded'
		},
		data
	})
}

//微信授权绑定手机号
export function WeChatBindPhone(data){
	return Http.request({
		url: `/auth/bind/getWxUserPhone`,
		method: 'post',
		data
	})
}

//绑定手机号
export function BindPhone(data){
	return Http.request({
		url: `/auth/bind/bindPhone`,
		method: 'post',
		data
	})
}

//注销账号 
export function AccountLogOff(data){
	return Http.request({
		url: `/auth/bind/cancellation`,
		method: 'post',
		data
	})
}

// 退出登录
export function OutLogin(data){
	return Http.request({
		url: `/auth/oauth/logout`,
		method: 'post',
		data
	})
}

